import React from "react";
import PropTypes from "prop-types";

/**
 * Renders a transparent background for a bar in a chart, making the entire area clickable.
 *
 * @param {object} props - The component props
 * @param {number} [props.x] - The x-coordinate of the bar
 * @param {number} [props.y] - The y-coordinate of the bar
 * @param {number} [props.width] - The width of the bar
 * @param {number} [props.height] - The height of the bar
 * @returns {React.ReactElement} A rect SVG element representing the bar background
 */
// eslint-disable-next-line id-length
const BarBackground = ({ x, y, width, height }) => (
  <rect
    x={x}
    y={y}
    width={width}
    height={height}
    fill="transparent"
    style={{ cursor: "pointer" }}
  />
);

BarBackground.propTypes = {
  // eslint-disable-next-line id-length
  x: PropTypes.number,
  // eslint-disable-next-line id-length
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
};

BarBackground.defaultProps = {
  // eslint-disable-next-line id-length
  x: 0,
  // eslint-disable-next-line id-length
  y: 0,
  width: 0,
  height: 0,
};

export default BarBackground;
